// extracted by mini-css-extract-plugin
export default {"card":"MaxSizedCard_card__aFJib"};